import { forwardRef } from 'react';
import { HubbleProvider } from '../../ThemeProvider/index.js';
import { CardDefaultElement } from './constants.js';
import { CardWrapper } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const Card = forwardRef(function ForwardedCard({
  ['aria-checked']: ariaChecked,
  as = CardDefaultElement,
  children,
  customBgColor,
  isRadio,
  padding = 'md',
  variant = 'outlined',
  ...props
}, ref) {
  const ROLE_RADIO = isRadio && {
    role: 'radio',
    'aria-checked': ariaChecked,
    type: 'button'
  };
  if (customBgColor && variant === 'inverse') {
    throw new Error("The customBgColor prop can only be used with the 'filled' or 'outlined' variant.");
  }
  if (variant === 'inverse') {
    return jsx(CardWrapper, {
      padding: padding,
      variant: "inverse",
      ...props,
      children: jsx(HubbleProvider, {
        scheme: "dark",
        children: children
      })
    });
  }
  return jsx(CardWrapper, {
    as: as,
    customBgColor: customBgColor,
    padding: padding,
    ref: ref,
    variant: variant,
    ...ROLE_RADIO,
    ...props,
    children: children
  });
});

export { Card };
